'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = exports.mapStateToProps = exports.LocationModalUnwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactInlinesvg = require('react-inlinesvg');

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _icons = require('constants/icons');

var _Modal = require('decorators/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _Sagas = require('decorators/Sagas/Sagas');

var _decorator = require('helpers/decorator');

var _deep = require('helpers/deep');

var _verify = require('helpers/verify');

var _bound = require('redux/saga/entities/bound');

var _locale = require('redux/modules/locale');

var _LocationForm = require('./LocationForm');

var _ThankYou = require('./ThankYou');

var _WaitlistForm = require('./WaitlistForm');

var _location = require('./location.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationModalUnwrapped = exports.LocationModalUnwrapped = function (_PureComponent) {
  (0, _inherits3.default)(LocationModalUnwrapped, _PureComponent);

  function LocationModalUnwrapped() {
    var _ref;

    var _temp, _this, _this2, _ret;

    (0, _classCallCheck3.default)(this, LocationModalUnwrapped);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = LocationModalUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(LocationModalUnwrapped)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
      isLocationSubmitted: false
    }, _this2.handleLocationSubmit = function () {
      return _this.setState({ isLocationSubmitted: true });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(LocationModalUnwrapped, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isPurchasableMsa = _props.isPurchasableMsa,
          isLocated = _props.isLocated,
          isWaitlisted = _props.isWaitlisted;
      var isLocationSubmitted = this.state.isLocationSubmitted;

      var shouldShowWaitlist = isLocated && !isPurchasableMsa;

      return _react2.default.createElement(
        'div',
        { className: 'modal__body' },
        _react2.default.createElement(
          'div',
          { className: 'modal__column' },
          _react2.default.createElement(
            'div',
            { className: 'location-modal' },
            _react2.default.createElement(_reactInlinesvg2.default, {
              key: 'location-modal.icon',
              className: 'location-modal__icon',
              src: _icons.LINEART_BLUE.map_pin
            }),
            // eslint-disable-next-line no-nested-ternary
            !isLocationSubmitted ? _react2.default.createElement(_LocationForm.LocationFormContainer, { onFormSubmit: this.handleLocationSubmit }) : isWaitlisted ? _react2.default.createElement(_ThankYou.ThankYou, null) : shouldShowWaitlist && _react2.default.createElement(_WaitlistForm.WaitlistFormContainer, null)
          )
        )
      );
    }
  }]);
  return LocationModalUnwrapped;
}(_react.PureComponent);

LocationModalUnwrapped.propTypes = {
  isPurchasableMsa: _propTypes2.default.bool.isRequired,
  isLocated: _propTypes2.default.bool.isRequired,
  isWaitlisted: _propTypes2.default.bool.isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  var _ref2 = (0, _locale.selectUserLocation)(state) || {},
      lat = _ref2.lat,
      lon = _ref2.lon;

  var userLocation = _bound.glsLocation.data(state, lat + '_' + lon);

  return {
    isLocated: !(0, _verify.isEmpty)(userLocation),
    isPurchasableMsa: (0, _deep.deepExtract)('msa.package_purchase', userLocation, false),
    isWaitlisted: !(0, _verify.isEmpty)(_bound.waitlistRequest.data(state))
  };
};

var Modal = exports.Modal = (0, _decorator.decorateWith)((0, _Modal2.default)({
  modalContentClass: 'modal__content--location-modal'
}), (0, _reactRedux.connect)(mapStateToProps), (0, _Sagas.withSagas)({
  watch: [_location.watchLocationForm, _location.watchWaitlistForm]
}))(LocationModalUnwrapped);